import { push } from "connected-react-router";

import { BASE_URL } from "config";
import { api } from "utils";
import * as base from '../base';


const endpoints = {
  list: `${BASE_URL}/api/v1/service/group/`,
  detail: (id) => `${BASE_URL}/api/v1/service/group/${id}/`,
  history: (id) => `${BASE_URL}/api/v1/service/group/${id}/history/`,
};

export const serviceGroupListLoad = (token, payload) => api.ListLoad(endpoints.list, token, payload);
export const serviceGroupDetailLoad = (token, { id }) => api.DetailLoad(endpoints.detail, token, { id });
export const serviceGroupUpdate = (token, data) => api.Update(endpoints.list, endpoints.detail, token, data);
export const serviceGroupDelete = (token, data) => api.Delete(endpoints.detail, token, data);
export const serviceGroupHistoryLoad = (token, payload) => api.DetailLoad(endpoints.history, token, { id: payload.id });


export const serviceGroup = {
  state: {
    ...base.ListState,
    ...base.DetailState,
    ...base.EditState,
    ...base.DeleteState,

    title: 'Услуги',
    urls: {
      list: () => `/service`,
      detail: () => `/service`,
    },
  },
  reducers: {
    ...base.ListReducers,
    ...base.DetailReducers,
    ...base.EditReducers,
    ...base.DeleteReducers,
  },
  effects: dispatch => ({
    async listLoad(payload, rootState) {
      await base.asyncListLoadRequest(dispatch, payload, rootState, 'serviceGroup', serviceGroupListLoad)
    },

    async detailLoad(payload, rootState) {
      await base.asyncDetailLoadRequest(dispatch, payload, rootState, 'serviceGroup', serviceGroupDetailLoad)
    },

    async update(payload, rootState) {
      await base.asyncUpdateRequest(dispatch, payload, rootState, 'serviceGroup', serviceGroupUpdate,
        async (data) => {
          dispatch['serviceGroup'].showEditForm({ show: false });
          const filter = rootState['serviceGroup'].filter;
          await dispatch['serviceGroup'].listLoad(filter);
        }
      );
    },

    async delete(payload, rootState) {
      await base.asyncDeleteRequest(dispatch, payload, rootState, 'serviceGroup', serviceGroupDelete,
        async (data) => {
          dispatch(push(rootState['serviceGroup'].urls.list()));
          const filter = rootState['serviceGroup'].filter;
          await dispatch['serviceGroup'].listLoad(filter);
        }
      );
    },
  }),
}